<template>
    <div class="electromechanical">
        <!-- 机电解析 -->
        <div class="left">
            <div class="item">
                <p class="title"><i><img src="@/assets/Analysissoftware/ic_001@2x.png" alt=""></i>肌电波形图</p>
                <div class="chart">
                    <div ref="emgWaveforms" style="width: 100%;height:360px"></div>
                </div>
            </div>
            <div class="bottom">
                <div class="items">
                    <p class="title"><i><img src="@/assets/Analysissoftware/ic_002@2x.png"></i>肌电平均值</p>
                    <div class="bottom_left">
                        <div class="average1">
                            <div class="list">
                                <p class="text green"><i><img src="@/assets/Analysissoftware/ic_max@2x.png"></i>最大值</p>
                                <b class="value green">{{EmgInfo.emgMax==null?0:EmgInfo.emgMax}}</b>
                            </div>
                            <div class="list">
                                <p class="text yellow"><i><img src="@/assets/Analysissoftware/ic_low@2x.png"></i>最小值</p>
                                <b class="value yellow">{{EmgInfo.emgMin==null?0:EmgInfo.emgMin}}</b>
                            </div>
                        </div>
                        <div class="average2">
                            <p class="text"><i><img src="@/assets/Analysissoftware/ic_average@2x.png" alt=""></i>平均值</p>
                            <b class="value">{{EmgInfo.emgAvg==null?0:EmgInfo.emgAvg}}</b>
                        </div>
                    </div>
                </div>
                <div class="items">
                    <p class="title"><i><img src="@/assets/Analysissoftware/ic_003@2x.png"></i>肌电标准差</p>
                    <div class="bottom_left">
                        <div class="average2">
                            <p class="text green"><i><img src="@/assets/Analysissoftware/ic_max@2x.png" alt=""></i>最大值</p>
                            <b class="value green">{{EmgInfo.emgSdMax==null?0:EmgInfo.emgSdMax}}</b>
                        </div>
                        <div class="average2">
                            <p class="text yellow"><i><img src="@/assets/Analysissoftware/ic_low@2x.png" alt=""></i>最小值</p>
                            <b class="value yellow">{{EmgInfo.emgSdMin==null?0:EmgInfo.emgSdMin}}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="Basicinfor">
                <label class="title">用户基本信息</label>
                <p class="item">部门：{{EmgInfo.deptName}}</p>
                <p class="item">姓名：{{EmgInfo.realName}}</p>
                <p class="item">性别：{{EmgInfo.sex}}</p>
                <p class="item">年龄：{{EmgInfo.age}}</p>
            </div>
            <div class="rightimg">
                <img src="@/assets/Analysissoftware/bg_right_botom@2x.png">
            </div>

        </div>

        <!-- 检测结果 -->
        <el-dialog
            :visible.sync="dialogVisible"
            width="800px"
            title="检测结果"
            :before-close="handleClose">
            <div class="Monitoringresults">
                <div class="item">
                    <p class="emotext">情绪稳定指数</p>
                    <div class="emotion">
                        <div class="good_img"><img src="@/assets/Analysissoftware/ic_good@2x.png"></div>
                        <div class="good_text">
                            <b>92</b>
                            <p>情绪稳定高</p>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <p class="emotext">心理健指数</p>
                    <div class="emotion">
                        <div class="good_img"><img src="@/assets/Analysissoftware/ic_bad@2x.png"></div>
                        <div class="good_text">
                            <b>92</b>
                            <p>心理健康程度低</p>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default{
    name:'electromechanical',
    data() {
        return {
            dialogVisible:false,
            EmgInfo:{},
            userId:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            time:null
        }
    },
    created(){
        this.getEmgInfo();
    },
    mounted() {
        var _this=this;
        setTimeout(() => {
            _this.time=setInterval(() => {
                _this.getEmgInfo();
            }, 1000);
        }, 2000);
    },
    methods: {
        getEmgInfo(){
            this.$Http_Post('/bioassay/soft/getEmgInfo',{userId:this.userId}).then(res=>{
                if(res.Code==0){
                    this.EmgInfo=res.Data;
                    this.emgWaveforms(res.Data.emgWaveforms);
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        handleClose(){
            this.dialogVisible=false;
        },
        emgWaveforms(data){
            var Xdata=[];
            for(let item in data){
                Xdata.push(item);
            }
            var myChart = this.$echarts.init(this.$refs.emgWaveforms);
            var option = {
                tooltip: {
                },
                grid: {
                    top:0,
                    left: 0,  
                    right: 0,
                    bottom:0
                },  
                xAxis: {
                    type: 'category',
                    data:Xdata,
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                yAxis: {
                    type: 'value',
                    axisLine: {lineStyle: {color: '#fff'}},
                },
                series:[
                    {
                        name:'排版总数',
                        data: data,
                        type: 'line',
                        smooth: true,
                        color: '#1FA1CC'  
                    }
                ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        }
    },
    destroyed(){
        clearInterval(this.time);
    }
}
</script>
<style>
img{width: 100%;display:block;}
.electromechanical{background:#291713;display: flex;min-height: 100%;padding: 15px;}
.electromechanical .left{flex: auto;margin-right: 10px;}
.electromechanical .left .item{margin: 0 0 10px;background:#61463F;padding-bottom: 20px;}
.electromechanical .left .item .title{background: #FF5733;color:#fff;font-size: 20px;display: flex;padding: 5px 10px;}
.electromechanical .left .item .title i{width:30px;display: inline-block;margin-right: 5px;}
.electromechanical .left .item .chart{background: #382C26;margin: 20px 20px 0;}
.electromechanical .left .bottom{margin-top:10px;display: flex;}
.electromechanical .left .bottom .items{background: rgba(255, 255, 255, 0.05);width: -webkit-fill-available;}
.electromechanical .left .bottom .items:first-child{margin-right: 10px;}
.electromechanical .left .bottom .items .title{background: #1F3E8C;color:#9FE635;font-size: 20px;display: flex;padding: 5px 10px;}
.electromechanical .left .bottom .items .title i{width:30px;display: inline-block;margin-right: 5px;}
.electromechanical .left .bottom .items .bottom_left{display: flex;}

.electromechanical .left .bottom .items .average1{margin: 0 20px;width: -webkit-fill-available;}
.electromechanical .left .bottom .items .average2{background:url("../../../assets/Analysissoftware/bg_square@2x.png") no-repeat;background-size: 100% 100%;margin:10px 20px;width: -webkit-fill-available; padding:20px;}
.electromechanical .left .bottom .items .average2 .text{font-size: 18px;color: #239FC2;display: flex;align-items: center;}
.electromechanical .left .bottom .items .average2 .text i{width: 30px;display: inline-block;}
.electromechanical .left .bottom .items .average2 .value{font-size: 90px;text-align: right;color: #239FC2;display: block;}
.electromechanical .left .bottom .items .average1 .list{background:url("../../../assets/Analysissoftware/bg_rectangle@2x.png") no-repeat;background-size: 100% 100%;margin: 10px 0;padding:5px 20px;}
.electromechanical .left .bottom .items .average1 .list .text{font-size: 18px;color: #239FC2;display: flex;align-items: center;}
.electromechanical .left .bottom .items .average1 .list .text i{width: 30px;display: inline-block;}
.electromechanical .left .bottom .items .average1 .list .value{font-size: 40px;text-align: right;color: #239FC2;display: block;}


.electromechanical .right{width:240px;display: inline-block;}
.electromechanical .right .Basicinfor{background:url("../../../assets/Analysissoftware/bg_personal@2x.png") no-repeat;height:360px;background-size: 100% 100%;width: 240px;}
.electromechanical .right .Basicinfor .title{font-size: 22px;color: #fff;display: block;text-align: right;padding:5px 20px 20px 0;}
.electromechanical .right .Basicinfor .item{font-size: 18px;color: #43B8D9;padding: 15px 0 0 20px;}
.electromechanical .right .startBtn{width: 100%;margin: 10px 0;}
.electromechanical .right .rightimg{width: 100%;margin-top: 10px;}
.electromechanical .green{color: #2BB361!important;}
.electromechanical .yellow{color: #E3C21B!important;}
.electromechanical .Monitoringresults{display:flex;}
.electromechanical .Monitoringresults .item{background: #F2F2F2;width:-webkit-fill-available;border: 1px solid #fff;padding: 20px;}
.electromechanical .Monitoringresults .item .emotext{font-size: 24px;color: #000;padding-bottom: 30px;}
.electromechanical .Monitoringresults .item .emotion{display: flex;}
.electromechanical .Monitoringresults .item .emotion .good_img{width: 104px;}
.electromechanical .Monitoringresults .item .emotion .good_text{color: #24AD5B;}
.electromechanical .Monitoringresults .item .emotion .good_text b{font-size: 48px;}
.electromechanical .Monitoringresults .item .emotion .good_text p{font-size: 24px;}
.electromechanical .el-dialog__header{background: #FF5733;text-align: center;}
.electromechanical .el-dialog__title,.electromechanical .el-dialog__close{color: #fff;}
</style>